import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { customBreakPointsProvider } from './breakpoints';
import { FlexAlignDirective } from './flex-align.directive';
import { FlexOffsetDirective } from './flex-offset.directive';
import { FlexOrderDirective } from './flex-order.directive';
import { FlexDirective } from './flex.directive';
import { LayoutAlignDirective } from './layout-align.directive';
import { LayoutShowHideDirective } from './layout-show-hide.directive';
import { LayoutDirective } from './layout.directive';

const ALL_DIRECTIVES = [
  FlexAlignDirective,
  FlexOffsetDirective,
  FlexOrderDirective,
  FlexDirective,
  LayoutAlignDirective,
  LayoutDirective,
  LayoutShowHideDirective,
];

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule.withConfig({
      disableDefaultBps: true,
    }),
  ],
  declarations: [...ALL_DIRECTIVES],
  exports: [...ALL_DIRECTIVES],
  providers: [customBreakPointsProvider],
})
export class LayoutModule {}
